import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Field, PickSelect } from "@/components/apply/Field";
import { COUNTRIES, TIMEZONES } from "@/data/options";
import { api, formatErr } from "@/lib/api";

const DIALS = [...new Set(COUNTRIES.map((c) => c.dial))];
const KEYS = ["full_name", "phone_code", "phone", "country", "city", "timezone", "business_name", "links"];

export const ProfileForm = ({ profile, onSaved }) => {
  const [form, setForm] = useState(() => Object.fromEntries(KEYS.map((k) => [k, profile[k] || ""])));
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const set = (k) => (v) => setForm({ ...form, [k]: v?.target ? v.target.value : v });

  const save = async () => {
    try {
      await api.put("/member/profile", form);
      toast.success("Profile updated");
      onSaved();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  const changePw = async () => {
    try {
      await api.post("/auth/change-password", pw);
      toast.success("Password changed");
      setPw({ current_password: "", new_password: "" });
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-3">
      <div className="lg:col-span-2 rounded-2xl border border-border bg-card p-6" data-testid="member-profile-form">
        <div className="grid gap-4 sm:grid-cols-2">
          <Field label="Full name"><Input value={form.full_name} onChange={set("full_name")} className="h-11 rounded-xl" data-testid="profile-full-name-input" /></Field>
          <Field label="Email"><Input value={profile.email} disabled className="h-11 rounded-xl" data-testid="profile-email-input" /></Field>
          <Field label="Phone">
            <div className="flex gap-2">
              <div className="w-28 shrink-0"><PickSelect value={form.phone_code} onChange={set("phone_code")} options={DIALS} testId="profile-phone-code-select" /></div>
              <Input value={form.phone} onChange={set("phone")} className="h-12 rounded-xl" data-testid="profile-phone-input" />
            </div>
          </Field>
          <Field label="Country"><PickSelect value={form.country} onChange={set("country")} options={COUNTRIES.map((c) => c.name)} testId="profile-country-select" /></Field>
          <Field label="City"><Input value={form.city} onChange={set("city")} className="h-11 rounded-xl" data-testid="profile-city-input" /></Field>
          <Field label="Time zone"><PickSelect value={form.timezone} onChange={set("timezone")} options={TIMEZONES} testId="profile-timezone-select" /></Field>
          <Field label="Business name" optional><Input value={form.business_name} onChange={set("business_name")} className="h-11 rounded-xl" data-testid="profile-business-input" /></Field>
          <Field label="Website / social" optional><Input value={form.links} onChange={set("links")} className="h-11 rounded-xl" data-testid="profile-links-input" /></Field>
        </div>
        <button onClick={save} className="mt-6 h-11 px-6 rounded-full bg-primary text-primary-foreground font-bold" data-testid="profile-save-button">Save profile</button>
      </div>
      <div className="rounded-2xl border border-border bg-card p-6 space-y-3" data-testid="member-password-form">
        <p className="font-bold">Change password</p>
        <Input type="password" placeholder="Current password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} className="h-11 rounded-xl" data-testid="password-current-input" />
        <Input type="password" placeholder="New password (8+ characters)" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="h-11 rounded-xl" data-testid="password-new-input" />
        <button onClick={changePw} className="h-11 w-full rounded-full border border-border font-bold hover:bg-secondary transition-colors" data-testid="password-change-button">Update password</button>
      </div>
    </div>
  );
};
